import { render, staticRenderFns } from "./topCom.vue?vue&type=template&id=5d4f1b35&scoped=true&"
import script from "./topCom.vue?vue&type=script&lang=ts&"
export * from "./topCom.vue?vue&type=script&lang=ts&"
import style0 from "./topCom.vue?vue&type=style&index=0&id=5d4f1b35&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f1b35",
  null
  
)

export default component.exports